import { useQuery } from "@tanstack/react-query"

import { useResortParam } from "@/hooks/useSkipassFlow"

import { bffApi } from "../apiClient"
import formatStartDate from "../helpers/formatStartDate"
import { Price, ProductType } from "../models"
import queryKeys from "../queryKeys"

interface PriceResponse {
  prices: Price[]
}

export interface UsePricesOptions {
  arrivalDate: Date
  productIds: string[]
  productTypeId: ProductType
  categoryId: number
}

const usePrices = (options: UsePricesOptions) => {
  const { arrivalDate } = options
  const formattedDate = formatStartDate(arrivalDate)
  const { resortExternalId } = useResortParam()

  return useQuery<PriceResponse>({
    queryKey: queryKeys.prices({
      arrivalDate: formattedDate,
      productIds: options.productIds,
      productTypeId: options.productTypeId,
      categoryId: options.categoryId,
    }),

    queryFn: async () => {
      const body = {
        ...options,
        resortId: resortExternalId,
        arrivalDate: formattedDate,
      }
      const res = await bffApi.post<PriceResponse>(`/prices`, body)
      return res.data
    },
    staleTime: 0,
    gcTime: 0,
  })
}

export default usePrices
